import ServiceBgImg1 from "../src/images/service2.png";
import ServiceBgImg2 from "../src/images/service3.png";
import ServiceBgImg3 from "../src/images/service4.png";
import ServiceBgImg4 from "../src/images/service5.png";

import serviceImg1 from "../src/images/svg/serviceimg_01.svg";
import serviceImg2 from "../src/images/svg/serviceimg_02.svg";
import serviceImg3 from "../src/images/svg/serviceimg_03.svg";
import serviceImg4 from "../src/images/svg/serviceimg_04.svg";

const Sdata = [
  {
    svgurl: serviceImg1,
    imgurl: ServiceBgImg1,
    title: 'Creative Design',
    pricetext: 'Starts from',
    price: '$99',
    desc: 'Web design refers to the design of websites that are displayed on the internet. It usually refers to the user experience aspects of website development',
  },

  {
    svgurl: serviceImg2,
    imgurl: ServiceBgImg2,
    title: 'Graphic Design',
    pricetext: 'Starts from',
    price: '$199',
    desc: 'Web design refers to the design of websites that are displayed on the internet. It usually refers to the user experience aspects of website development',
  },

  {
    svgurl: serviceImg3,
    imgurl: ServiceBgImg3,
    title: 'UI/UX Design',
    pricetext: 'Starts from',
    price: '$299',
    desc: 'Web design refers to the design of websites that are displayed on the internet. It usually refers to the user experience aspects of website development',
  },

  {
    svgurl: serviceImg4,
    imgurl: ServiceBgImg4,
    title: 'UI/UX Design',
    pricetext: 'Starts from',
    price: '$399',
    desc: 'Web design refers to the design of websites that are displayed on the internet. It usually refers to the user experience aspects of website development',
  },

];

export default Sdata;